<template>
    <div class="ticketDet">
        <el-dialog title="票券详情" :visible.sync="dialogVisible" width="540px">
            <div class="refuse_box" v-if="memo">{{memo}}</div>
             <div class="pup_detTop">
                <div class="imgBox">
                    <img :src="eventinfo.coveratturlid" alt="">
                    <span class="title">{{eventinfo.title}}</span>
                </div>
                 <p><img :src="detTime" alt=""> {{eventinfo.begintime}}-{{eventinfo.endtime}}</p>
                 <p><img :src="detAddr" alt=""> {{eventinfo.address}}</p>
             </div>
            <!--下面-->
            <div class="pup_detBot">
                <p class="tickNum">票券张数（{{ticketcount}}）</p>
                <div class="ticket_wrapPoup" data-mcs-theme="dark">
                    <div class="ticketScroll">
                        <div class="ticket_box" v-for="(item,index) in ticketlist" :key="index">
                            <div class="ticket_top">
                                <p><span>{{item.ticketname}}</span><span>¥{{item.uprice}}</span></p>
                                <p class="status"><span>状态</span><span v-bind:class="{yellowText:item.ticketstatus>=9||item.ticketstatus==31||item.ticketstatus==1,greenText:item.ticketstatus>=10&&item.ticketstatus!=31,redText:item.ticketstatus==3,grayText:item.ticketstatus==100}">{{item.ticketstatusname}}</span></p>
                            </div>
                            <div class="ticket_list" v-for="(item2,index2) in item.joinlist" :key="index2">
                                <p class="join">参加人（{{index2+1}}/{{item.joinlist.length}}）</p>
                                <p v-if="item2.ticketno"><label>票号</label>{{item2.ticketno}}</p>
                                <!--<p><label>姓名</label>{{item2.joinername}}</p>-->
                                <!--<p><label>手机</label>{{item2.joinermobile}}</p>-->
                                 <p v-for="(item3,index3) in item2.formdatalist" :key="index3">
                                     <label>{{item3.formname}}</label>{{item3.formvalue}}
                                 </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getEventOrderDetail,getEventOrderTicket} from 'api/personalCenterApi'
    import {mapActions} from 'vuex'
    import $ from 'jquery'
    import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js'
    import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css'
    export default {
        name: "ticketDet",
        data(){
            return{
                dialogVisible:false,
                detTime:require('@/common/images/hd/detTime.png'),
                detAddr:require('@/common/images/hd/detAddr.png'),
                eventinfo:{},
                ticketlist:[],
                ticketcount:'', //票券张数
                memo:'', //拒绝理由
            }
        },
        methods:{
            open(eventid,orderno,form){
                console.log(eventid,orderno,form)
                this.dialogVisible=true;
                if(form===1){ //单个票券详情
                    this._getTicketDet(eventid,orderno)
                }else{
                    this._getInfo(eventid,orderno)
                }
            },
            //获取票券详情
            _getInfo(id,orderno){
                this.setLoading(true);
                let param={
                    eventid:id,
                    orderno:orderno,
                };
                getEventOrderDetail({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false);
                        this.eventinfo=data.data.eventinfo;
                        this.ticketlist=data.data.ticketlist;
                        // this.ticketcount=this.ticketlist[0].ticketcount;
                        this.ticketcount=data.data.itemcount;
                        this.memo=data.data.memo
                        $('.ticket_wrapPoup').mCustomScrollbar({
                            // alwaysShowScrollbar:false,
                            // axis: "y",
                            // autoExpandScrollbar:true,
                            autoHideScrollbar:true
                        });
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            //获取单个票券详情
            _getTicketDet(id,itemid){
                this.setLoading(true);
                let param={
                    eventid:id,
                    itemid:itemid,
                };
                getEventOrderTicket({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false);
                        this.eventinfo=data.data.eventinfo;
                        this.ticketlist=data.data.ticketlist;
                        // this.ticketcount=this.ticketlist[0].ticketcount;
                        this.ticketcount=data.data.itemcount;
                        this.memo=data.data.memo;
                        $('.ticket_wrapPoup').mCustomScrollbar({
                            autoHideScrollbar:true
                        });
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading',
            ])
        }
    }
</script>

<style lang="scss">
    .ticketDet{
        .el-dialog{
            border-radius:4px;
            .el-dialog__header{
                border-bottom: 1px solid #eee;
                .el-dialog__title{
                    font-size: 14px;
                }
            }
            .el-dialog__body{
                padding: 0 0;
            }
        }
        .refuse_box{
            height:auto;
            background:rgba(255,233,233,1);
            border-radius:4px;
            color: #F56C6C;
            padding: 12px 20px;
            line-height: 20px;
        }
        .pup_detTop{
            border-bottom: 1px dashed #e5e5e5;
            padding: 20px 20px 10px;
            .imgBox{
                display: flex;
                margin-bottom: 10px;
                img{
                    width:154px;
                    min-width: 154px;
                    height:87px;
                    margin-right: 12px;
                    border-radius: 4px;
                }
                .title{
                    font-size: 16px;
                    color: #333;
                    line-height: 22px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 4;
                    overflow: hidden;
                }
            }
            p{
                display: flex;
                align-items: center;
                line-height: 24px;
                margin-bottom: 6px;
                img{
                    margin-right: 10px;
                }
            }
        }
        .pup_detBot{
            padding-left: 20px;
            padding-bottom: 20px;
            .tickNum{
                margin: 20px 0;
            }
            .ticket_wrapPoup{
                height: auto;
                max-height: 400px;
                overflow-y: auto;
                .ticketScroll{
                    padding: 5px;
                    .ticket_box{
                        background:rgba(255,255,255,1);
                        box-shadow:0px 2px 6px 0px rgba(0,0,0,0.1);
                        padding: 20px;
                        margin-bottom: 20px;
                        .ticket_top{
                            color: #333;
                            line-height: 20px;
                            padding-bottom: 20px;
                            border-bottom: 1px dashed #E5E5E5;
                            p{
                                display: flex;
                                justify-content: space-between;
                            }
                            .status{
                                margin-top: 10px;
                                .yellowText{
                                    color: #FFA904
                                }
                                .greenText{
                                    color: #0ABF53;
                                }
                                .redText{
                                    color: #F56C6C;
                                }
                                .grayText{
                                    color: #999;
                                }
                            }
                        }
                        .ticket_list{
                            margin-top: 20px;
                            .join{
                                color: #333;
                                font-weight: bold;
                            }
                            p{
                                line-height: 20px;
                                margin-top: 10px;
                                color: #666;
                                label{
                                    max-width: 112px;
                                    margin-right: 20px;
                                }
                            }
                        }
                    }
                    .ticket_box:last-child{
                        margin-bottom: 0;
                    }
                }
            }
        }
        .mCSB_inside > .mCSB_container {
            margin-right: 20px;
        }
    }
    /*滚动条样式*/
    .mCS-dark.mCSB_scrollTools .mCSB_draggerRail{
        display: none;
    }
    .mCSB_scrollTools .mCSB_dragger{
        height: 60px!important;
    }
    .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{
        background-color: #ccc !important;
    }
</style>